module.exports = __webpack_public_path__ + "img/1-Stepp-Splash-Page-MVP-Option-2.3fc03100.png";